import React from 'react';
import styled from 'styled-components';
import {
  withTypo3,
  WithTypo3Props
} from '../../provider/Typo3Provider/withTypo3';

interface Typo3ErrorProps {}

const ErrorContainer = styled.div`
  color: red;
  font-size: 2em;
  text-align: center;
`;

const Typo3Error = ({ typo3: { error } }: Typo3ErrorProps & WithTypo3Props) => {
  if (process.env.NODE_ENV !== 'production') {
    return error ? (
      <ErrorContainer>
        {error.name} {error.message}
      </ErrorContainer>
    ) : null;
  }
  return null;
};

export default withTypo3(Typo3Error);
